'use client';

import { type LayoutNode } from 'shop-ui/types/basic';
import { ELEMENT_TYPE } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.COPYRIGHT,
    name: 'Copyright',
    enable: true,
    editable: false,
    next: null,
    deletable: false,
};

export function createCopyright() {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {},
    };
}

export function generate() {
    const copyright = createCopyright();

    return combineComponent(i18n.gettext('區塊'), [copyright], {
        editable: false,
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
    });
}
